// node_modules
import { 
    FC,
    MouseEvent
} from "react";
// styles
import styles from "./topbarMenuItem.module.scss";

type TTopbarMenuItemProps = {
    href: string,
    text: string,
    anchorOnClickAsync: ((event: MouseEvent<HTMLAnchorElement>) => Promise<void>) | undefined
}

export const TopbarMenuItem: FC<TTopbarMenuItemProps> = ({href, text, anchorOnClickAsync}: TTopbarMenuItemProps) => {
    return (
        <div className={styles.topbarMenuItem}>
            {anchorOnClickAsync ?
                <a className={styles.topbarMenuItemLink} href={href} onClick={anchorOnClickAsync}>{text}</a>
                :
                <a className={styles.topbarMenuItemLink} href={href}>{text}</a>
            }
        </div>
    );
};
